export default __webpack_public_path__ + "static/media/c.47cef3e6.svg";